import React, { useState } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Button, ModalWindow } from '../../atoms';
import { default as t } from '../../../utils/i18n';
import './create-report.scss';
import ReportWrapper from '../report-wrapper/report-wrapper';


const CreateReportAccordion = props => {
  const [showAnswerModal, setShowAnswerModal] = useState(false);
  const [showFilterErrorModal, setShowFilterErrorModal] = useState(false);
  const [expand, setExpand] = useState(false);

  const handleClick = () => {
    setShowAnswerModal(true);
  };

  const handleCreateReport = () => {
    setShowFilterErrorModal(true);
  };
  const handleOnCloseModal = () => {
    setShowAnswerModal(false);
  };

  const handleOnCloseErrorModal = () => {
    setShowFilterErrorModal(false);
  };
  const handleExpand = () => {
    if(expand){
      setExpand(false);
    }
    else{
      setExpand(true);
    }
    
  };

  const updateTableListing = () => {
      props.evUpdateTableListing(true);
      setExpand(false);
   }
  
  return (
    <>
      <Accordion expanded={expand} disabled={false}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          onClick={handleExpand}
        >
         <>{t('create.report.accordian.label')}{expand}</> 
        </AccordionSummary>
        <AccordionDetails>
          <div className="instruction-container">
            <div className="info-instruction">
              <h3 className="gold">{t('create.report.instruction1')}</h3>
              <h3>{t('create.report.instruction2')}</h3>
            </div>
            <div className="ques-instruction">
              <span>{t('create.report.show.answer.question')}</span>
              <button onClick={handleClick}>
                <i className="far fa-comment-dots"></i>
                {t('create.report.show.answer.label')}
              </button>
            </div>
          </div>
          <div className="filter-container">
            <div className="filter-heading">
              <div className="heading">
                {/* <h4>{t('create.report.filter.heading')}</h4> */}
                {/* <span>DateRange_Adv~Advertiser1+Advertiser2+Advertiser3_Ind~All_Cou~All_KPIs~All_KPIM~All_JasHay_date</span> */}
              </div>
             
            </div>
            <div className="filter-options">
              
            </div>
            <ReportWrapper  updateTableListing={updateTableListing}/>
           
          </div>
        </AccordionDetails>
      </Accordion>

      <ModalWindow
        className="fqa-modal--showanswer"
        isOpen={showAnswerModal}
        onRequestClose={handleOnCloseModal}
        heading={t('create.report.show.answer.question')}
      >
        <p className="fqa-model-showanswer--message">
          {t('create.report.show.answer.instruction1')}
        </p>

        <p className="fqa-model-showanswer--message">
          {t('create.report.show.answer.instruction2')}
        </p>

        <h4 className="fqa-model-showanswer--message">
          {t('create.report.show.answer.option.heading')}
        </h4>

        <div className="rules">
        <div className="options">
            <span className="veiw">
              <i className="eva eva-alert-circle-outline"></i>
              <span>{t('create.report.show.answer.option.options1.type')}</span>
            </span>
            <p className="fqa-model-showanswer--message">
              {t('create.report.show.answer.option.options1.desc')}
            </p>
          </div>
          <div className="options">
            <span className="veiw">
              <i className="eva eva-checkmark-circle-2-outline"></i>
              <span>{t('create.report.show.answer.option.options2.type')}</span>
            </span>
            <p className="fqa-model-showanswer--message">
              {t('create.report.show.answer.option.options2.desc')}
            </p>
          </div>
          <div className="options">
            <span className="in-progress">
              <i className="far fa-clock"></i>
              <span>{t('create.report.show.answer.option.options3.type')}</span>
            </span>
            <p className="fqa-model-showanswer--message">
              {t('create.report.show.answer.option.options3.desc')}
            </p>
          </div>
          <div className="options">
            <span className="ready">
              <i className="far fa-bell"></i>
              <span>{t('create.report.show.answer.option.options4.type')}</span>
            </span>
            <p className="fqa-model-showanswer--message">
              {t('create.report.show.answer.option.options4.desc')}
            </p>
          </div>
          <div className="options">
            <span className="error">
              <i className="eva eva-alert-triangle-outline"></i>
              <span>{t('create.report.show.answer.option.options5.type')}</span>
            </span>
            <p className="fqa-model-showanswer--message">
              {t('create.report.show.answer.option.options5.desc')}
            </p>
          </div>
         
        </div>
      </ModalWindow>

      <ModalWindow
        className="fqa-modal--createerror"
        isOpen={showFilterErrorModal}
        onRequestClose={handleOnCloseErrorModal}
        heading={t('create.report.error.modal.heading')}
      >
        <p className="fqa-model-createerror--message">
          {t('create.report.error.modal.instruction1')}
        </p>

        <ul>
          <li>{t('create.report.error.modal.rule1')}</li>
          <li>{t('create.report.error.modal.rule2')}</li>
          <li>{t('create.report.error.modal.rule3')}</li>
          <li>{t('create.report.error.modal.rule4')}</li>
          <li>{t('create.report.error.modal.rule5')}</li>
        </ul>

        <p className="fqa-model-createerror--message">
          {t('create.report.error.modal.instruction2')}
        </p>
      </ModalWindow>
    </>
  );
};

export default CreateReportAccordion;
